import type { PropsWithChildren } from 'react';
import type { SxProps } from '@mui/material';

import Stack from '@mui/material/Stack';

export const RenovationExecutorFieldContainer = ({
  children,
  sx,
}: PropsWithChildren<{ sx?: SxProps }>) => (
  <Stack spacing={1} flexBasis="50%" sx={sx}>
    {children}
  </Stack>
);
